import React from "react";
import { Route, Routes } from "react-router-dom";
import Signin from "./Signin";
import Signup from "./Signup";
import Todo from "./Todo";
import "./style.scss"
let LazySignin = React.lazy(()=>import("./Signin"))
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<React.Suspense fallback="Loading..."><LazySignin /></React.Suspense>} />
        {/* <Route path="/" element={<Signin/>} /> */}
        <Route path="/signup" element={ <Signup/>}/>
        <Route path="/todo" element={<Todo/>}/>
    </Routes>
    </div>
  );
}

export default App;
